import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	clockIn: null,
	attendance: null,
	date: null,
	error: "",
	loading: false,
};

// ADD_attendance
export const addClockIn = createAsyncThunk("attendance", async (values) => {
	try {
		const { data } = await axios({
			method: "post",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json;charset=UTF-8",
			},
			url: `attendance`,
			data: {
				...values,
			},
		});
		toast.success("Attendance Added");
		return {
			data,
			message: "success",
		};
	} catch (error) {
		toast.error("Error in adding Attendance try again");
		console.log(error.message);
		return {
			message: "error",
		};
	}
});

export const getCurrentUserClockInStatus = createAsyncThunk(
	"clockIn/loadSingleClockIn",
	async (id) => {
		try {
			const data = await axios.get(`attendance/${id}/last`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

// add Manual Attendance
export const addManualAttendance = createAsyncThunk(
	"attendance/addManualAttendance",
	async (values) => {
		// console.log(values)
		try {
			const { data } = await axios({
				method: "post",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `attendance?query=manualPunch`,
				data: {
					...values,
				},
			});
			toast.success("Attendance Added");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			const errorMessage = error.response?.data?.message || "Error in adding Attendance. Try again.";
			toast.error(errorMessage);
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

export const editManualAttendance = createAsyncThunk(
	"attendance/editManualAttendance",
	async ({values, id}) => {
		// console.log(values)
		try {
			const { data } = await axios({
				method: "put",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `attendance/${id}`,
				data: {
					...values,
				},
			});
			// toast.success("Attendance Added");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			const errorMessage = error.response?.data?.message || "Error in adding Attendance. Try again.";
			toast.error(errorMessage);
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);


export const CreateTimeSheet = createAsyncThunk(
	"attendance/CreateTimeSheet",
	async ({id,values}) => {
		console.log({id}, {values});
		
		// console.log(values)
		try {
			const { data } = await axios({
				method: "post",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `attendance/timeSheet/${id}`,
				data: {
					...values,
				},
			});
			toast.success("CreateTimeSheet Added");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			const errorMessage = error.response?.data?.message || "Error in adding Attendance. Try again.";
			toast.error(errorMessage);
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

// get all attendance list paginated
export const loadAllAttendancePaginated = createAsyncThunk(
	"attendance/loadAllAttendancePaginated",
	async ({ page, startdate, enddate, limit }) => {
		try {
			const { data } = await axios({
				method: "get",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `attendance?page=${page}&count=${limit}&startdate=${startdate}&enddate=${enddate}`,
			});
			return data;
		} catch (error) {
			toast.error("Error in getting Attendance list try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

// get all attendance
export const loadAllAttendance = createAsyncThunk(
	"attendance/loadAllAttendance",
	async () => {
		try {
			const { data } = await axios({
				method: "get",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `attendance?query=all`,
			});
			return data;
		} catch (error) {
			toast.error("Error in getting Attendance list try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

export const currentDate = createAsyncThunk(
	"attendance/currentDate",
	async () => {
		try {
			const { data } = await axios({
				method: "get",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `attendance/current/date`,
			});
			return data;
		} catch (error) {
			toast.error("Error in getting Attendance list try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

// get single attendance
export const loadSingleAttendance = createAsyncThunk(
	"attendance/loadSingleAttendance",
	async (id) => {
		try {
			const { data } = await axios({
				method: "get",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `attendance/${id}`,
			});

			return data;
		} catch (error) {
			toast.error("Error in getting Attendance list try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

// loadAttendanceByUserId
export const loadAttendanceByUserId = createAsyncThunk(
	"attendance/loadAttendanceByUserId",
	async (id) => {
		console.log(id);
		
		try {
			const { data } = await axios({
				method: "get",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `attendance/${id}/user`,
			});

			return data;
		} catch (error) {
			toast.error("Error in getting Attendance list try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

// Save check-out time
export const saveCheckOutTime = createAsyncThunk(
	"attendance/saveCheckOutTime",
	async (id) => {
		console.log(id);
		console.log(id.id);
		console.log(id.outTime);
		
		try {
			const { data } = await axios({
				method: "post",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `attendance/CheckOutTime/${id.id}`,
				data: {
					outTime: id.outTime,
					checkOutComment: id.checkOutComment,
					totalBreakHours: id.totalBreakHours 
				},
			});
			console.log("dd", data)
			toast.success("Check-out time saved successfully.");
			return data;
		} catch (error) {
			toast.error("Error in saving check-out time, please try again.");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);



const clockInSlice = createSlice({
	name: "clockIn",
	initialState,
	reducers: {
		clearAttendance: (state) => {
			state.attendance = null;
		},
		clearAttendanceList: (state) => {
			state.list = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(addClockIn.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addClockIn.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addClockIn.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 3) ====== builders for getCurrentUserClockInStatus ======

		builder.addCase(getCurrentUserClockInStatus.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getCurrentUserClockInStatus.fulfilled, (state, action) => {
			state.loading = false;
			state.clockIn = action.payload.data;
		});

		builder.addCase(getCurrentUserClockInStatus.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for loadAllAttendancePaginated ======

		builder.addCase(loadAllAttendancePaginated.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(loadAllAttendancePaginated.fulfilled, (state, action) => {
			state.loading = false;

			state.list = action.payload;
		});

		builder.addCase(loadAllAttendancePaginated.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for loadAllAttendance ======

		builder.addCase(loadAllAttendance.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(loadAllAttendance.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(loadAllAttendance.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for currentDate ======

		builder.addCase(currentDate.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(currentDate.fulfilled, (state, action) => {
			state.loading = false;
			state.date = action.payload.currentDate;
		});

		builder.addCase(currentDate.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for addManualAttendance ======

		builder.addCase(addManualAttendance.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addManualAttendance.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addManualAttendance.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

				// 5) ====== builders for editManualAttendance ======

				builder.addCase(editManualAttendance.pending, (state) => {
					state.loading = true;
				});
		
				builder.addCase(editManualAttendance.fulfilled, (state, action) => {
					state.loading = false;
				});
		
				builder.addCase(editManualAttendance.rejected, (state, action) => {
					state.loading = false;
					state.error = action.payload.message;
				});

		// 4) ====== builders for CreateTimeSheet ======

		builder.addCase(CreateTimeSheet.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(CreateTimeSheet.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(CreateTimeSheet.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for loadSingleAttendance ======

		builder.addCase(loadSingleAttendance.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(loadSingleAttendance.fulfilled, (state, action) => {
			state.loading = false;

			state.attendance = action.payload;
		});

		builder.addCase(loadSingleAttendance.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for loadAttendanceByUserId ======

		builder.addCase(loadAttendanceByUserId.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(loadAttendanceByUserId.fulfilled, (state, action) => {
			state.loading = false;

			state.list = action.payload;
		});

		builder.addCase(loadAttendanceByUserId.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		builder.addCase(saveCheckOutTime.pending, (state) => {
			state.loading = true;
		});
	
		builder.addCase(saveCheckOutTime.fulfilled, (state, action) => {
			state.loading = false;
			state.attendance = action.payload; // or any other state update
		});
	
		builder.addCase(saveCheckOutTime.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
	},
});

export default clockInSlice.reducer;
export const { clearAttendance, clearAttendanceList } = clockInSlice.actions;
